export enum TimekeepingFrequencyType {
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY"
}

export interface TimekeepingFrequencyModel {
  id: string;
  type: string;
  reportFrequencyType: TimekeepingFrequencyType;
}